<template>
  <div class="ui container landing" >
    <div v-if="loading" class="loading">
      <vue-simple-spinner></vue-simple-spinner>
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="contentData" class="content">
        <PointsMessage v-bind:points="pointsEarned" v-if="pointsEarned" @showLeaderboard="onShowLeaderboard"/>
        <ContentBox ref="contentBox" v-bind:booster-type="contentData.booster.type" 
                    v-bind:body="contentData.booster.body"
                    v-bind:sash="contentData.booster.sash"
                    v-bind:questionText="contentData.booster.questionText"
                    v-bind:boosterData="contentData.booster.data"
                    v-bind:leaderboards="contentData.booster.leaderboards"
                    v-bind:selection="selection"
                    v-bind:pageType="pageType"
                    v-bind:api="api"
                    v-bind:learnerId="learnerId"
                    v-bind:programId="contentData.booster.programId"
                    v-bind:boosterId="boosterId"
                    @earnedPoints="onEarnedPoints"/>
        
        <ContentFooter v-bind:image="contentData.booster.banner"
                       v-bind:programTitle="contentData.booster.programTitle"/>
    </div>
      
  </div>
</template>

<script>
import ContentBox from './ContentBox.vue'
import ContentFooter from './ContentFooter.vue'
import PointsMessage from './PointsMessage.vue'

export default {
  name: 'BoosterLanding',
  props: ['api'],
  components: {
      ContentBox,
      ContentFooter,
      PointsMessage
  },
  data () {
      return {
          loading: true,
          contentData: null,
          error: null,
          pageType: '',
          pathParts: [],
          selection: 1,
          pointsEarned: 0,
          learnerId: -1,
          boosterId: -1
      }
  },
  mounted() {
      this.pathParts = this.$route.path.split("/")
      this.pageType = this.pathParts[2]

      if (this.pageType == 'landing') {
          this.learnerId = parseInt(this.pathParts[5])
          this.boosterId = parseInt(this.pathParts[3])
          this.selection = parseInt(this.pathParts[4])
      }
      else if(this.pageType == 'unsubscribe') {
          this.learnerId = parseInt(this.pathParts[4])
      }

      this.fetchData()
      
  },
  methods: {
      async fetchData () {
          this.error = this.post = null
          this.loading = true

          let response = await this.api.get('/api/content',
          {
              params: {
                  p: this.$route.path
              }
          }).catch(err => err);

          this.loading = false

          if (response instanceof Error) {
              this.error = response.message;
          }
          else {
              this.contentData = response.data;
          }
      },
      onEarnedPoints: function (points) {
          this.pointsEarned = points;
      },
      onShowLeaderboard: function() {
          this.$refs.contentBox.showLeaderboard()
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing {
    max-width: 840px;
}
@media (max-width: 640px) {
    .landing {
        max-width: 10000px;
        width: 100% !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        height: 100%;
    }
    .content {
        height: 100%;
    }
}
</style>
